import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useForm } from "react-hook-form";
import OButton from "components/reusable/OButton";
import ErrorMessage from "components/ErrorMessage";
import { apiPost, apiPut, apiGet } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import useToastContext from "hooks/useToastContext";

const AddProductModal = ({ isOpen, onClose, product, onSuccess }) => {
  const notification = useToastContext();

  
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [preview, setPreview] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors }
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      title: product?.title || "",
      categoryId: product?.category || "",
      category: product?.category || "", // Add this line to set the category dat
      subCategoryId: product?.subCategory || "",
      description: product?.description || "",
    },
  });;

  // Prefill form for edit
  useEffect(() => {
    if (isOpen) {
      apiGet(apiPath.categoryList).then(res => setCategories(res?.data?.results?.docs || []));
setTimeout(
  () => {
   setValue("categoryId", product?.category?._id || product?.category || "");
    setValue("category", product?.category?._id || product?.category || "");
    setValue("subCategoryId", product?.subCategory || "");
    setValue("description", product?.description || "");
  },[200]
)      
if (product) {
        reset({
          product_name: product.product_name || "",
          product_id: product.product_id || "",
          categoryId: product.category?._id || product.category || "",
          category: product.category?._id || product.category || "",
          subcategory_id: product.subcategory_id || "",
          bnTitle: product.bnTitle || "",
          product_subtitle: product.product_subtitle || "",
          bn_sub_title: product.bn_sub_title || "",
        });
        // Set preview for existing images
        if (product.product_image) {
          // If product_image is an array, map it; if string, wrap in array
          const images = Array.isArray(product.product_image)
            ? product.product_image
            : [product.product_image];
          setPreview(
            images
              .filter(Boolean)
              .map(img =>
                img.startsWith("http")
                  ? img
                  : `https://agrigate-app-public.s3.ap-south-1.amazonaws.com/${img}`
              )
          );
        } else {
          setPreview([]);
        }
        setFile([]); // Clear file input for edit
      } else {
        reset();
        setPreview([]);
        setFile([]);
      }
      // Fetch categories
    }
  }, [isOpen, product, reset]);

  useEffect(() => {
    const category = watch("category");
    // if (category) {
    //   apiGet(`${apiPath.subCategoryList}?category_id=${category}`).then(res =>
    //     setSubcategories(res?.data?.results?.docs || [])
    //   );
    // } else {
    //   setSubcategories([]);
    // }
  }, [watch("category")]);

  // File upload handler and validation
  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    setFile(files);
    setPreview(files.map(file => URL.createObjectURL(file)));
  };

  const validate = () => {
    if (file.length > 5) {
      alert("You cannot upload more than 5 files");
      return false;
    }
    return true;
  };
console.log("category", watch("category"));
  const onSubmit = async (data) => {
    if (!validate()) return;
    setLoading(true);
    const payload = {
      product_name: data.product_name,
      product_id: data.product_id,
      category_id: data.category,
      subcategory_id: data.subcategory_id,
      bnTitle: data.bnTitle,
      product_subtitle: data.product_subtitle,
      bn_sub_title: data.bn_sub_title,
      // Add file/image handling as needed
    };

    let formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => formData.append(key, value));
    file.forEach(f => formData.append('files', f));

    let result;
    if (product && product._id) {
      result = await apiPut(`${apiPath.editProduct}/${product._id}`, formData); // <-- use formData here
    } else {
      result = await apiPost(apiPath.addProduct, formData); // <-- use formData here
    }

    setLoading(false);
    console.log("Result from 137",result?.data?.success)

    if (result?.data?.success) {
      notification.success(result.data.message);

      onSuccess && onSuccess();
      onClose();
      reset();
      setFile([]);
      setPreview([]);
    } else {
      // handle error, show toast, etc.
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={product ? "Edit Product" : "Add Product"}
      className="fixed inset-0 flex items-center justify-center z-50"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50"
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <h2 className="font-medium text-black mb-3 text-xl">
          {product ? "Edit Product" : "Add Product"}
        </h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Product Name - full width */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Product Name<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              {...register("product_name", { required: "Product Name is required" })}
              className="w-full border p-2 rounded text-sm"
            />
            <ErrorMessage message={errors?.product_name?.message} />
          </div>
          {/* 2-column grid for Category and Product ID */}
          <div className="mb-4 grid grid-cols-1 md:grid-cols-1 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Category<span className="text-red-500">*</span>
              </label>
              <select
                {...register("category", { required: "Category is required" })}
                className="w-full border p-2 rounded text-sm"
              >
                <option value="">Select Category</option>
                {categories.map(cat => (
                  <option key={cat._id} value={cat._id}>{cat.title}</option>
                ))}
              </select>
              <ErrorMessage message={errors?.category?.message} />
            </div>
            {/* <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Product ID<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                {...register("product_id", { required: "Product ID is required" })}
                className="w-full border p-2 rounded text-sm"
              />
              <ErrorMessage message={errors?.product_id?.message} />
            </div> */}
          </div>
          {/* Subcategory - full width */}
          {/* <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Subcategory
            </label>
            <select
              {...register("subcategory_id")}
              className="w-full border p-2 rounded text-sm"
            >
              <option value="">Select Subcategory</option>
              {subcategories.map(sub => (
                <option key={sub._id} value={sub._id}>{sub.title}</option>
              ))}
            </select>
          </div> */}
          {/* 2-column grid for Bangla Title and Subtitle */}
          <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Bangla Title
              </label>
              <input
                type="text"
                {...register("bnTitle")}
                className="w-full border p-2 rounded text-sm"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Product Subtitle
              </label>
              <input
                type="text"
                {...register("product_subtitle")}
                className="w-full border p-2 rounded text-sm"
              />
            </div>
          </div>
          {/* Bangla Subtitle - full width */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Product Bangla Subtitle
            </label>
            <input
              type="text"
              {...register("bn_sub_title")}
              className="w-full border p-2 rounded text-sm"
            />
          </div>
          {/* File Upload - full width */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Product Image
            </label>
            <input
              type="file"
              multiple
              onChange={handleFileUpload}
              className="w-full border p-2 rounded text-sm"
            />
            {/* Preview */}
            <div className="flex flex-wrap mt-2">
              {preview.map((src, idx) => (
                <img key={idx} src={src} alt="preview" className="w-16 h-16 object-cover mr-2 mb-2" />
              ))}
            </div>
          </div>
          <div className="flex justify-end">
            <OButton label={product ? "Update" : "Add"} type="submit" disabled={loading} />
            <button
              type="button"
              onClick={onClose}
              className="ml-4 text-black bg-[#E1E1E1] px-4 py-2 rounded"
              disabled={loading}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddProductModal;